export const OTP_LENGTH = 6;
export const MINIMUM_PASSWORD_LENGTH = 6;
export const MAXIMUM_PASSWORD_LENGTH = 18;
export const RESEND_OTP_LIMITS = 4;
export const RESEND_OTP_DELAY_IN_SECONDS = 30;
export const PASSWORD_MIN_LENGTH = 6;
export const MAX_PROFILE_RESUME_SIZE = 500 * 1024; // This size in Bytes
export const MAX_PROFILE_IMAGE_SIZE = 500 * 1024; // This size in Bytes
export const MAX_INTREST_LIMIT_OF_PROFILE = 3; // Intrest limit of industries's intrest
export const MAX_SALARY_LIMIT = 10000000; // 100 Lakh